import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from '../../../style'
import Row from '../../common/Row'

const BTN_BORDER_RADIUS = 6

const POSITIONS = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
}

const resetStyles = `
    border: none;
    background: none;
    cursor: pointer;
    text-decoration: none;
    outline: none;
`
const RoundButton = styled.button`
    ${resetStyles}
    height: 34px;
    width: 130px;
    border-top-left-radius: ${({ position }) => (position === POSITIONS.LEFT ? `${BTN_BORDER_RADIUS}px` : 0)};
    border-bottom-left-radius: ${({ position }) => (position === POSITIONS.LEFT ? `${BTN_BORDER_RADIUS}px` : 0)};
    border-top-right-radius: ${({ position }) => (position === POSITIONS.RIGHT ? `${BTN_BORDER_RADIUS}px` : 0)};
    border-bottom-right-radius: ${({ position }) => (position === POSITIONS.RIGHT ? `${BTN_BORDER_RADIUS}px` : 0)};
    background-color: ${({ active }) => theme[active ? 'lightBlue1' : 'lightBlue2']};
    color: ${({ active }) => theme[active ? 'white' : 'lightBlue1']};
    font-family: Montserrat;
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 1px;
`

const ButtonGroup = ({
    leftTitle,
    rightTitle,
    activeIndex,
    alignSelf,
    style,
    onClick,
    ...rest
}) => (
    <Row
        justifyContent="center"
        alignItems="center"
        style={{
            alignSelf,
            ...style,
        }}
        {...rest}
    >
        <Row justifyContent="center" alignItems="center">
            <RoundButton
                position={POSITIONS.LEFT}
                active={activeIndex === 0}
                onClick={() => { onClick(0) }}
            >
                {leftTitle}
            </RoundButton>
            <RoundButton
                position={POSITIONS.RIGHT}
                active={activeIndex === 1}
                onClick={() => { onClick(1) }}
            >
                {rightTitle}
            </RoundButton>
        </Row>
    </Row>
)

ButtonGroup.propTypes = {
    leftTitle: PropTypes.string,
    rightTitle: PropTypes.string,
    activeIndex: PropTypes.number,
    alignSelf: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'stretch',
    ]),
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    onClick: PropTypes.func,
}

ButtonGroup.defaultProps = {
    leftTitle: 'LEFT',
    rightTitle: 'RIGHT',
    activeIndex: 0,
    alignSelf: 'flex-start',
    style: {},
    onClick: () => {},
}

export default ButtonGroup
